/**
 * kw-pdp-sticky.js — mobile floating buy bar for product pages.
 * Fades in a fixed bottom bar (price + Buy Now) once the user
 * scrolls past the primary add-to-cart button on narrow viewports.
 */
(function () {
  var MOBILE_MAX = 900;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isPdp() { return /\/products\//.test(window.location.pathname); }
  function init() {
    if (!isPdp()) return;
    var addBtn = document.querySelector('add-to-cart-component button[name="add"], button[name="add"]');
    if (!addBtn) return;
    var priceEl = document.querySelector('.product-price, .price, [data-testid="product-price"]');
    var titleEl = document.querySelector('h1');
    var image = document.querySelector('.product-media img, .product__media img, main img');
    if (document.getElementById('kw-pdp-bar')) return;

    var bar = document.createElement('div');
    bar.id = 'kw-pdp-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="kw-pdp-bar__inner">' +
      '  <div class="kw-pdp-bar__thumb">' + (image ? '<img src="' + image.currentSrc + '" alt="">' : '') + '</div>' +
      '  <div class="kw-pdp-bar__meta">' +
      '    <div class="kw-pdp-bar__title">' + (titleEl ? titleEl.textContent.trim().slice(0, 40) : '') + '</div>' +
      '    <div class="kw-pdp-bar__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
      '  </div>' +
      '  <button type="button" class="kw-pdp-bar__cta">Buy Now</button>' +
      '</div>';
    document.body.appendChild(bar);
    var cta = bar.querySelector('.kw-pdp-bar__cta');
    cta.addEventListener('click', function () {
      addBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () {
        addBtn.classList.add('kw-pulse');
        setTimeout(function () { addBtn.classList.remove('kw-pulse'); }, 900);
      }, 500);
    });

    // Show/hide logic
    function toggle() {
      var narrow = window.innerWidth <= MOBILE_MAX;
      var rect = addBtn.getBoundingClientRect();
      var addBtnVisible = rect.top < window.innerHeight && rect.bottom > 0;
      var show = narrow && !addBtnVisible;
      bar.classList.toggle('kw-pdp-bar--show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);
    toggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
